<template>
    <section ref="sectionRef" class="h-[600px] relative overflow w-full">
        
        <div class="absolute top-20 right-0 w-4/5 h-full">
            <DeviceWrapper deviceType="laptop" :imageSrc="webImage" :width="100" :x="3" :y="laptopY" :z="0" />
        </div>
        <div class="absolute bottom-0 left-0 w-1/2 h-full">
            <DeviceWrapper deviceType="phone" :imageSrc="appImage" :width="80" :x="3" :y="phoneY" :z="0" />
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import DeviceWrapper from '../../components/DeviceWrapper.vue'

const props = defineProps({
    webImage: {
        type: String,
        default: ''
    },
    appImage: {
        type: String,
        default: ''
    }
})

const sectionRef = ref(null)
const laptopY = ref(-55)
const phoneY = ref(55)

// Scroll-driven y range: laptop -15 -> -35, phone 15 -> 35 as section scrolls into view
const laptopYMin = -5
const laptopYMax = -35
const phoneYMin = 15
const phoneYMax = 35

function onScroll() {
    if (!sectionRef.value) return
    const rect = sectionRef.value.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const sectionTop = rect.top
    const sectionHeight = rect.height

    // Progress 0 = section just entering from bottom, 1 = section has scrolled past top
    const progress = Math.max(0, Math.min(1, (viewportHeight - sectionTop) / (viewportHeight + sectionHeight)))

    laptopY.value = laptopYMin + (laptopYMax - laptopYMin) * progress
    phoneY.value = phoneYMin + (phoneYMax - phoneYMin) * progress
}

onMounted(() => {
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
})

onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
})
</script>
